export function onceAsync<T>(factory: () => Promise<T>) {
  let promise: Promise<T> | null = null;

  const fn = async () => {
    if (!promise) {
      const p = factory();
      promise = p.then(
        (result) => {
          promise = Promise.resolve(result); // lock in success
          return result;
        },
        (err) => {
          promise = null; // clear on failure
          throw err;
        },
      );
    }
    return promise;
  };

  fn.reset = () => {
    promise = null;
  };

  return fn;
}

export function onceAsyncMap<K, V>(factory: (key: K) => Promise<V>) {
  const cache = new Map<K, Promise<V>>();

  const fn = async (key: K) => {
    let promise = cache.get(key);
    if (!promise) {
      const p = factory(key);
      promise = p.then(
        (result) => {
          cache.set(key, Promise.resolve(result));
          return result;
        },
        (err) => {
          cache.delete(key);
          throw err;
        },
      );
      cache.set(key, promise);
    }
    return promise;
  };

  fn.reset = (key?: K) => {
    if (key !== undefined) cache.delete(key);
    else cache.clear();
  };

  return fn;
}
